import React, { useEffect, useRef, useState } from 'react';

const RogerVideoSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Extract video ID from YouTube URL
  const videoId = 'JIGZjFwWckU';

  return (
    <section
      ref={sectionRef}
      className="py-32 bg-[#202020] relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#efede6] tracking-tight transition-all duration-1000 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            How Contemplate helped Roger deepen his relationship with his children
          </h2>
          <p className={`text-lg text-[#efede6]/50 max-w-3xl mx-auto mt-6 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            Roger Rippy, a father of two children and a senior yoga teacher (used to own 7 yoga studios in the US) talks about how Contemplate helped him deepen his relationship with his children.
          </p>
        </div>

        {/* Video Embed */}
        <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="relative w-full max-w-[800px] mx-auto rounded-2xl overflow-hidden shadow-2xl bg-[#202020] aspect-video">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}`}
              title="How Contemplate helped Roger deepen his relationship with his children"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RogerVideoSection;

